var _defs, _g, _path, _path2, _path3, _rect, _g2, _text, _text2, _g3, _text3, _circle, _g4, _g5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBank1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 555,
    height: 481.219,
    viewBox: "0 0 555 481.219",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23603",
    "data-name": "Path 23603",
    d: "M-83.66,0h30.771V20.363H-83.66Z",
    fill: "rgba(0,0,0,0.7)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23608",
    "data-name": "Path 23608",
    d: "M0,0H29.579V22.184H0Z",
    fill: "rgba(0,0,0,0.7)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14580",
    "data-name": "Group 14580",
    transform: "translate(-1083 -3149.891)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14249",
    "data-name": "Group 14249",
    transform: "translate(1248.5 3423.883)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3076",
    "data-name": "Rectangle 3076",
    fill: "#fff",
    stroke: "#dae2d6",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 325.021,
    height: 207.227,
    rx: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 324.021,
    height: 206.227,
    rx: 11.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8603",
    "data-name": "Group 8603",
    transform: "translate(13.815 17.499)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "SWIFT_network_details",
    "data-name": "SWIFT network details",
    transform: "translate(45.129 20)",
    fill: "#030303",
    fontSize: 18,
    fontFamily: "Poppins-SemiBold, Poppins",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SWIFT network details")), /*#__PURE__*/React.createElement("g", {
    id: "Group_8597",
    "data-name": "Group 8597",
    transform: "translate(0 86.575)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3079",
    "data-name": "Rectangle 3079",
    width: 292.785,
    height: 89.338,
    rx: 6,
    fill: "#dff5ea"
  }), /*#__PURE__*/React.createElement("text", {
    id: "To_receive_foreign_currencies_USD.",
    "data-name": "To receive foreign currencies & USD.",
    transform: "translate(39.603 28.736)",
    fill: "#111",
    fontSize: 13,
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "To receive foreign currencies &amp; USD.")), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-check-circle",
    "data-name": "Icon awesome-check-circle",
    d: "M14.032,7.3A6.735,6.735,0,1,1,7.3.563,6.735,6.735,0,0,1,14.032,7.3ZM6.518,10.863l5-5a.435.435,0,0,0,0-.614L10.9,4.638a.434.434,0,0,0-.615,0L6.211,8.713l-1.9-1.9a.435.435,0,0,0-.615,0l-.614.614a.435.435,0,0,0,0,.614L5.9,10.863a.435.435,0,0,0,.615,0Z",
    transform: "translate(15.095 16.937)",
    fill: "#2bd06f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8502",
    "data-name": "Group 8502",
    transform: "translate(15.657 42.366)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "All_incoming_funds_will_be_automatically_routed_to_USD_wallet.",
    "data-name": "All incoming funds will be automatically routed to USD wallet.",
    transform: "translate(23.946 0)",
    fill: "#111",
    fontSize: 13,
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 14
  }, "All incoming funds will be "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 34
  }, "automatically routed to USD wallet.")), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-check-circle-2",
    "data-name": "Icon awesome-check-circle",
    d: "M14.032,7.3A6.735,6.735,0,1,1,7.3.563,6.735,6.735,0,0,1,14.032,7.3ZM6.518,10.863l5-5a.435.435,0,0,0,0-.614L10.9,4.638a.434.434,0,0,0-.615,0L6.211,8.713l-1.9-1.9a.435.435,0,0,0-.615,0l-.614.614a.435.435,0,0,0,0,.614L5.9,10.863a.435.435,0,0,0,.615,0Z",
    transform: "translate(-0.563 2.201)",
    fill: "#2bd06f"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "Account_number_8850602369575_",
    "data-name": "Account number 8850602369575 ",
    transform: "translate(6.447 50.84)",
    fill: "#777",
    fontSize: 13,
    fontFamily: "Poppins-Light, Poppins",
    fontWeight: 300
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Account number"), /*#__PURE__*/React.createElement("tspan", {
    fill: "#111",
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 19
  }, "8850602369575 "))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8598",
    "data-name": "Group 8598",
    transform: "translate(6.447 0.921)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "globe_2_",
    "data-name": "globe (2)",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8334",
    "data-name": "Group 8334",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1425",
    "data-name": "Path 1425",
    d: "M27.439,16.647,21.391,9.131a.915.915,0,0,0-1.378,0l-3.057,3.8H14.679V9.052a30.733,30.733,0,0,0,4.955-.524l.057-.011a25.115,25.115,0,0,0,2.782-.7.884.884,0,0,0-.533-1.686c-.584.185-1.192.348-1.818.489a13.759,13.759,0,0,0-2.007-4.078A11.968,11.968,0,0,1,25.863,13.49a.884.884,0,0,0,1.768-.047A13.815,13.815,0,1,0,4.3,23.817a.924.924,0,0,0,.117.115l.043.034a13.761,13.761,0,0,0,9.361,3.664c6.148,0,10.117-3.549,10.759-9.545h2.173a.884.884,0,0,0,.688-1.438ZM8.253,12.931a23.175,23.175,0,0,1,.54-4.263,31.165,31.165,0,0,0,4.118.383v3.88Zm6.426-5.647V3.111a.884.884,0,1,0-1.768,0V7.283a29.44,29.44,0,0,1-3.646-.33c1.021-3.11,2.7-5.184,4.555-5.184,1.761,0,3.5,2,4.552,5.184A29.453,29.453,0,0,1,14.679,7.284ZM5.6,22.619A12.04,12.04,0,0,1,9.5,2.571,13.885,13.885,0,0,0,7.512,6.62c-.625-.142-1.231-.3-1.814-.488a.884.884,0,1,0-.533,1.686c.607.192,1.238.362,1.887.51a24.729,24.729,0,0,0-.568,4.6H3.2a.884.884,0,1,0,0,1.768H6.484a25.032,25.032,0,0,0,.572,4.6c-.65.149-1.282.319-1.891.511a.884.884,0,0,0,.266,1.727A.9.9,0,0,0,5.7,21.5a27.358,27.358,0,0,1,8.122-1.165q.449,0,.892.012a.9.9,0,0,0,.908-.859.884.884,0,0,0-.859-.908q-.467-.013-.941-.013a31.513,31.513,0,0,0-5.028.4A23.176,23.176,0,0,1,8.253,14.7h7.281l-1.567,1.948a.884.884,0,0,0,.689,1.438h2.019a7.434,7.434,0,0,1-4.256,5.01A6.365,6.365,0,0,1,5.6,22.619Zm18.158-6.3a.884.884,0,0,0-.883.836c-.141,2.619-1.307,8.709-9.06,8.709a12.008,12.008,0,0,1-3.028-.386,9.728,9.728,0,0,0,2.385-.783c3.2-1.518,5.351-4.529,5.351-7.492a.884.884,0,0,0-.885-.884H16.5L20.7,11.1l4.2,5.221Z",
    transform: "translate(-0.005)",
    fill: "#030303"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "globe_2_2",
    "data-name": "globe (2)",
    transform: "translate(10.776 11.096)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8334-2",
    "data-name": "Group 8334",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1425-2",
    "data-name": "Path 1425",
    d: "M24.687,17.269a.884.884,0,0,0-.883.836c-.141,2.619-1.307,8.709-9.06,8.709a12.008,12.008,0,0,1-3.028-.386,9.728,9.728,0,0,0,2.385-.783c3.2-1.518,5.351-4.529,5.351-7.492a.884.884,0,0,0-.885-.884H17.427l4.2-5.221,4.2,5.221Z",
    transform: "translate(-11.716 -12.048)",
    fill: "#12a15a"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14250",
    "data-name": "Group 14250",
    transform: "translate(1083 3149.891)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8434",
    "data-name": "Group 8434",
    transform: "translate(0 0)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1333",
    "data-name": "Path 1333",
    d: "M895.45,446.744l-333.272.893c-13.6.037-24.6,10.833-24.561,24.115l.531,189.055c.037,13.281,11.094,24.018,24.7,23.982l333.272-.893c13.6-.036,24.6-10.833,24.561-24.115l-.531-189.055C920.109,457.445,909.052,446.708,895.45,446.744Z",
    transform: "translate(-537.617 -446.744)",
    fill: "#030303"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1335",
    "data-name": "Path 1335",
    d: "M1076.915,446.744l-154.193.423a118.618,118.618,0,0,0,7.221,36.914c21.112,56.885,87.262,95.388,171.411,105.021l-.324-118.376A24.048,24.048,0,0,0,1076.915,446.744Z",
    transform: "translate(-718.488 -446.744)",
    fill: "#176b41"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1336",
    "data-name": "Path 1336",
    d: "M538.024,547.568l.075,27.516L686.707,447.829l-32.313.089Z",
    transform: "translate(-537.818 -447.279)",
    fill: "#12a15a",
    opacity: 0.2,
    style: {
      mixBlendMode: "luminosity",
      isolation: "isolate"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1337",
    "data-name": "Path 1337",
    d: "M990.279,446.722a206.281,206.281,0,0,1-12.174,70.857c-26.053,71.726-85.7,106.744-116.814,125.013-39.929,23.444-81.721,35.826-121.491,41.428l247.544-.679a23.448,23.448,0,0,0,23.384-23.513l-.53-193.3A19.864,19.864,0,0,0,990.279,446.722Z",
    transform: "translate(-628.288 -446.189)",
    fill: "#12a15a",
    opacity: 0.18
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3056",
    "data-name": "Rectangle 3056",
    width: 51.785,
    height: 51.785,
    rx: 25.893,
    transform: "translate(28.975 19.968)",
    fill: "#fff"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "_185-united_states_of_america",
    "data-name": "185-united states of america",
    transform: "translate(41.632 36.784)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2500",
    "data-name": "Rectangle 2500",
    width: 26.894,
    height: 16.635,
    fill: "#d80027"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7436",
    "data-name": "Group 7436",
    transform: "translate(0 2.144)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2501",
    "data-name": "Rectangle 2501",
    width: 26.894,
    height: 2.144,
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2502",
    "data-name": "Rectangle 2502",
    width: 26.894,
    height: 2.144,
    transform: "translate(0 4.116)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2503",
    "data-name": "Rectangle 2503",
    width: 26.894,
    height: 2.144,
    transform: "translate(0 8.231)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2507",
    "data-name": "Rectangle 2507",
    width: 26.894,
    height: 2.144,
    transform: "translate(0 14.491)",
    fill: "#d80027"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2504",
    "data-name": "Rectangle 2504",
    width: 26.894,
    height: 2.144,
    transform: "translate(0 12.347)",
    fill: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2505",
    "data-name": "Rectangle 2505",
    width: 13.863,
    height: 9.953,
    transform: "translate(0 0)",
    fill: "#2e52b2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7437",
    "data-name": "Group 7437",
    transform: "translate(1.408 1.599)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_221",
    "data-name": "Path 221",
    d: "M83.308,160.624l-.223.687h-.722l.584.424-.223.687.584-.424.584.424-.223-.687.584-.424h-.722Z",
    transform: "translate(-79.311 -158.145)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_222",
    "data-name": "Path 222",
    d: "M83.531,207.084l-.223-.687-.223.687h-.722l.584.424-.223.687.584-.424.584.424-.223-.687.584-.424Z",
    transform: "translate(-79.311 -201.439)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_223",
    "data-name": "Path 223",
    d: "M27.169,207.084l-.223-.687-.223.687H26l.584.424-.223.687.584-.424.584.424-.223-.687.584-.424Z",
    transform: "translate(-26.001 -201.439)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_224",
    "data-name": "Path 224",
    d: "M26.946,160.624l-.223.687H26l.584.424-.223.687.584-.424.584.424-.223-.687.584-.424h-.722Z",
    transform: "translate(-26.001 -158.145)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_225",
    "data-name": "Path 225",
    d: "M83.308,114.85l-.223.687h-.722l.584.424-.223.687.584-.424.584.424-.223-.687.584-.424h-.722Z",
    transform: "translate(-79.311 -114.85)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_226",
    "data-name": "Path 226",
    d: "M26.946,114.85l-.223.687H26l.584.424-.223.687.584-.424.584.424-.223-.687.584-.424h-.722Z",
    transform: "translate(-26.001 -114.85)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_227",
    "data-name": "Path 227",
    d: "M139.67,160.624l-.223.687h-.722l.584.424-.223.687.584-.424.584.424-.223-.687.584-.424h-.722Z",
    transform: "translate(-132.621 -158.145)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_228",
    "data-name": "Path 228",
    d: "M139.893,207.084l-.223-.687-.223.687h-.722l.584.424-.223.687.584-.424.584.424-.223-.687.584-.424Z",
    transform: "translate(-132.621 -201.439)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_229",
    "data-name": "Path 229",
    d: "M196.256,207.084l-.223-.687-.223.687h-.722l.584.424-.223.687.584-.424.584.424-.223-.687.584-.424Z",
    transform: "translate(-185.931 -201.439)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230",
    "data-name": "Path 230",
    d: "M196.033,160.624l-.223.687h-.722l.584.424-.223.687.584-.424.584.424-.223-.687.584-.424h-.722Z",
    transform: "translate(-185.931 -158.145)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_231",
    "data-name": "Path 231",
    d: "M139.67,114.85l-.223.687h-.722l.584.424-.223.687.584-.424.584.424-.223-.687.584-.424h-.722Z",
    transform: "translate(-132.621 -114.85)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_232",
    "data-name": "Path 232",
    d: "M196.033,114.85l-.223.687h-.722l.584.424-.223.687.584-.424.584.424-.223-.687.584-.424h-.722Z",
    transform: "translate(-185.931 -114.85)",
    fill: "#f0f0f0"
  })))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "_21_600.00",
    "data-name": "$21,600.00",
    transform: "translate(29.454 137.592)",
    fill: "#fff",
    fontSize: 27,
    fontFamily: "Poppins-SemiBold, Poppins",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "$21,600.00"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    id: "My_balance",
    "data-name": "My balance",
    transform: "translate(29.454 98.121)",
    fill: "#fff",
    fontSize: 12,
    fontFamily: "Poppins-Regular, Poppins",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "My balance"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_8444",
    "data-name": "Group 8444",
    transform: "translate(29.454 181.466)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "USD_account",
    "data-name": "USD account",
    transform: "translate(0 14)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "Poppins-Regular, Poppins"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "USD account")), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-arrow-down",
    "data-name": "Icon ionic-ios-arrow-down",
    d: "M16.644,11.5a.847.847,0,0,1,1.2,0,.858.858,0,0,1,0,1.205l-5.1,5.1a.849.849,0,0,1-1.173.025L6.436,12.705a.851.851,0,0,1,1.2-1.205Z",
    transform: "translate(95.629 -2.877)",
    fill: "#61ce65"
  }))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    id: "USD",
    transform: "translate(94.07 53.361)",
    fill: "#fff",
    fontSize: 21,
    fontFamily: "Poppins-SemiBold, Poppins",
    fontWeight: 600,
    letterSpacing: "0.07em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "USD"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_108",
    "data-name": "Ellipse 108",
    cx: 6.443,
    cy: 6.443,
    r: 6.443,
    transform: "translate(250.778 139.879)",
    fill: "#12a15a",
    opacity: 0.39
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14251",
    "data-name": "Group 14251",
    transform: "translate(1101.6 3359.589)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2988",
    "data-name": "Rectangle 2988",
    fill: "#fff",
    stroke: "#d7dfe6",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 131.902,
    height: 221.057,
    rx: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 130.902,
    height: 220.057,
    rx: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "SGD_EUR_GBP_JPY_HKD",
    "data-name": "SGD EUR GBP JPY HKD",
    transform: "translate(24.426 37.984)",
    fill: "#111",
    fontSize: 15,
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500,
    letterSpacing: "-0.02em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SGD"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 40
  }, "EUR"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 80
  }, "GBP"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 120
  }, "JPY"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 160
  }, "HKD")), /*#__PURE__*/React.createElement("g", {
    id: "_109-united_kingdom",
    "data-name": "109-united kingdom",
    transform: "translate(76.288 103.057)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_38",
    "data-name": "Rectangle 38",
    width: 29.177,
    height: 19.452,
    transform: "translate(0 0)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M16.412,85.33H12.765v7.9H0v3.647H12.765v7.9h3.647v-7.9H29.177V93.232H16.412Z",
    transform: "translate(0 -85.33)",
    fill: "#d80027"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_43",
    "data-name": "Group 43",
    transform: "translate(17.76 13.109)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M393.785,315.358l6.737,3.743v-3.743Z",
    transform: "translate(-389.104 -315.358)",
    fill: "#0052b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M311.652,315.358l11.417,6.343v-1.794l-8.189-4.549Z",
    transform: "translate(-311.652 -315.358)",
    fill: "#0052b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M320.028,349.652,311.652,345v4.654Z",
    transform: "translate(-311.652 -343.309)",
    fill: "#0052b4"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    d: "M311.652,315.358l11.417,6.343v-1.794l-8.189-4.549Z",
    transform: "translate(-293.892 -302.249)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    d: "M311.652,315.358l11.417,6.343v-1.794l-8.189-4.549Z",
    transform: "translate(-293.892 -302.249)",
    fill: "#d80027"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_44",
    "data-name": "Group 44",
    transform: "translate(0 13.108)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    d: "M5.148,315.356,0,318.216v-2.86Z",
    transform: "translate(0 -315.356)",
    fill: "#0052b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    d: "M35.456,329.51v5.536H25.491Z",
    transform: "translate(-24.038 -328.703)",
    fill: "#0052b4"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M8.189,315.358,0,319.907V321.7H0l11.417-6.343Z",
    transform: "translate(0 -302.249)",
    fill: "#d80027"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_45",
    "data-name": "Group 45"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M6.737,134.7,0,130.958V134.7Z",
    transform: "translate(0 -128.358)",
    fill: "#0052b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    d: "M11.417,91.673,0,85.33v1.794l8.189,4.549Z",
    transform: "translate(0 -85.33)",
    fill: "#0052b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M53.366,85.33l8.376,4.654V85.33Z",
    transform: "translate(-50.325 -85.33)",
    fill: "#0052b4"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M11.417,91.673,0,85.33v1.794l8.189,4.549Z",
    transform: "translate(0 -85.33)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M11.417,91.673,0,85.33v1.794l8.189,4.549Z",
    transform: "translate(0 -85.33)",
    fill: "#d80027"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_46",
    "data-name": "Group 46",
    transform: "translate(17.76 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M421.659,149.306l5.148-2.86v2.86Z",
    transform: "translate(-415.39 -142.963)",
    fill: "#0052b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    d: "M311.652,90.867V85.331h9.965Z",
    transform: "translate(-311.652 -85.331)",
    fill: "#0052b4"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    d: "M314.881,91.673l8.189-4.549V85.33h0l-11.417,6.343Z",
    transform: "translate(-293.892 -85.33)",
    fill: "#d80027"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eu",
    transform: "translate(76.4 62.057)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    d: "M0,0H29.579V20.36H0Z",
    fill: "#039"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7425",
    "data-name": "Group 7425",
    transform: "translate(8.023 3.562)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7357",
    "data-name": "Group 7357",
    transform: "translate(5.764 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b",
    transform: "translate(0.714)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M-6.823-23.7l-.288.961.48.1Z",
    transform: "translate(7.111 23.704)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    d: "M.288,1.057,0,.1.48,0Z",
    transform: "translate(0.576 1.057) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "c",
    transform: "translate(0.713 0.39)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7352",
    "data-name": "Group 7352",
    transform: "translate(1.114 0) rotate(72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-2",
    "data-name": "a",
    d: "M.288,0,0,.961l.48.1Z",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    d: "M.288,1.057,0,.1.48,0Z",
    transform: "translate(0.576 1.057) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7353",
    "data-name": "Group 7353",
    transform: "matrix(-0.809, 0.588, -0.588, -0.809, 1.087, 1.179)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-3",
    "data-name": "a",
    d: "M.288,0,0,.961l.48.1Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    "data-name": "Path 158",
    d: "M.288,1.057,0,.1.48,0Z",
    transform: "translate(0.576 1.057) rotate(180)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7356",
    "data-name": "Group 7356",
    transform: "translate(1.292 1.907) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7354",
    "data-name": "Group 7354",
    transform: "translate(0.109 1.191) rotate(-72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-4",
    "data-name": "a",
    d: "M.288,1.057,0,.1.48,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    "data-name": "Path 159",
    d: "M.288,0,0,.961l.48.1Z",
    transform: "translate(0.576 1.057) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7355",
    "data-name": "Group 7355",
    transform: "matrix(-0.809, -0.588, 0.588, -0.809, 0.466, 1.194)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-5",
    "data-name": "a",
    d: "M.288,1.057,0,.1.48,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    d: "M.288,0,0,.961l.48.1Z",
    transform: "translate(0.576 1.057) rotate(180)",
    fill: "#fc0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7363",
    "data-name": "Group 7363",
    transform: "translate(5.764 11.527)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b-2",
    "data-name": "b",
    transform: "translate(0.714 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-6",
    "data-name": "a",
    d: "M-6.823-23.7l-.288.961.48.1Z",
    transform: "translate(7.111 23.704)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    "data-name": "Path 161",
    d: "M.288,1.057,0,.1.48,0Z",
    transform: "translate(0.576 1.057) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "c-2",
    "data-name": "c",
    transform: "translate(0.713 0.39)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7358",
    "data-name": "Group 7358",
    transform: "translate(1.114 0) rotate(72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-7",
    "data-name": "a",
    d: "M.288,0,0,.961l.48.1Z",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    "data-name": "Path 162",
    d: "M.288,1.057,0,.1.48,0Z",
    transform: "translate(0.576 1.057) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7359",
    "data-name": "Group 7359",
    transform: "matrix(-0.809, 0.588, -0.588, -0.809, 1.087, 1.179)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-8",
    "data-name": "a",
    d: "M.288,0,0,.961l.48.1Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    d: "M.288,1.057,0,.1.48,0Z",
    transform: "translate(0.576 1.057) rotate(180)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7362",
    "data-name": "Group 7362",
    transform: "translate(1.292 1.907) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7360",
    "data-name": "Group 7360",
    transform: "translate(0.109 1.191) rotate(-72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-9",
    "data-name": "a",
    d: "M.288,1.057,0,.1.48,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164",
    "data-name": "Path 164",
    d: "M.288,0,0,.961l.48.1Z",
    transform: "translate(0.576 1.057) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7361",
    "data-name": "Group 7361",
    transform: "matrix(-0.809, -0.588, 0.588, -0.809, 0.466, 1.194)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-10",
    "data-name": "a",
    d: "M.288,1.057,0,.1.48,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165",
    "data-name": "Path 165",
    d: "M.288,0,0,.961l.48.1Z",
    transform: "translate(0.576 1.057) rotate(180)",
    fill: "#fc0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "e",
    transform: "translate(0 0.421)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7369",
    "data-name": "Group 7369",
    transform: "translate(0 5.342)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b-3",
    "data-name": "b",
    transform: "translate(0.714 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-11",
    "data-name": "a",
    d: "M-6.823-23.7l-.288.961.48.1Z",
    transform: "translate(7.111 23.704)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_166",
    "data-name": "Path 166",
    d: "M.288,1.057,0,.1.48,0Z",
    transform: "translate(0.576 1.057) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "c-3",
    "data-name": "c",
    transform: "translate(0.713 0.39)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7364",
    "data-name": "Group 7364",
    transform: "translate(1.114 0) rotate(72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-12",
    "data-name": "a",
    d: "M.288,0,0,.961l.48.1Z",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_167",
    "data-name": "Path 167",
    d: "M.288,1.057,0,.1.48,0Z",
    transform: "translate(0.576 1.057) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7365",
    "data-name": "Group 7365",
    transform: "matrix(-0.809, 0.588, -0.588, -0.809, 1.087, 1.179)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-13",
    "data-name": "a",
    d: "M.288,0,0,.961l.48.1Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    "data-name": "Path 168",
    d: "M.288,1.057,0,.1.48,0Z",
    transform: "translate(0.576 1.057) rotate(180)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7368",
    "data-name": "Group 7368",
    transform: "translate(1.292 1.907) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7366",
    "data-name": "Group 7366",
    transform: "translate(0.109 1.191) rotate(-72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-14",
    "data-name": "a",
    d: "M.288,1.057,0,.1.48,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    "data-name": "Path 169",
    d: "M.288,0,0,.961l.48.1Z",
    transform: "translate(0.576 1.057) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7367",
    "data-name": "Group 7367",
    transform: "matrix(-0.809, -0.588, 0.588, -0.809, 0.466, 1.194)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-15",
    "data-name": "a",
    d: "M.288,1.057,0,.1.48,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_170",
    "data-name": "Path 170",
    d: "M.288,0,0,.961l.48.1Z",
    transform: "translate(0.576 1.057) rotate(180)",
    fill: "#fc0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7375",
    "data-name": "Group 7375",
    transform: "matrix(-0.809, -0.588, 0.588, -0.809, 4.202, 2.722)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b-4",
    "data-name": "b",
    transform: "translate(0.714 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-16",
    "data-name": "a",
    d: "M.288,0,0,.961l.48.1Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_171",
    "data-name": "Path 171",
    d: "M.288,1.057,0,.1.48,0Z",
    transform: "translate(0.576 1.057) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "c-4",
    "data-name": "c",
    transform: "translate(0.713 0.39)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7370",
    "data-name": "Group 7370",
    transform: "translate(1.114 0) rotate(72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-17",
    "data-name": "a",
    d: "M.288,0,0,.961l.48.1Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    "data-name": "Path 172",
    d: "M.288,1.057,0,.1.48,0Z",
    transform: "translate(0.576 1.057) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7371",
    "data-name": "Group 7371",
    transform: "matrix(-0.809, 0.588, -0.588, -0.809, 1.087, 1.179)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-18",
    "data-name": "a",
    d: "M.288,0,0,.961l.48.1Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    d: "M.288,1.057,0,.1.48,0Z",
    transform: "translate(0.576 1.057) rotate(180)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7374",
    "data-name": "Group 7374",
    transform: "translate(1.292 1.907) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7372",
    "data-name": "Group 7372",
    transform: "translate(0.109 1.191) rotate(-72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-19",
    "data-name": "a",
    d: "M.288,1.057,0,.1.48,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_174",
    "data-name": "Path 174",
    d: "M.288,0,0,.961l.48.1Z",
    transform: "translate(0.576 1.057) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7373",
    "data-name": "Group 7373",
    transform: "matrix(-0.809, -0.588, 0.588, -0.809, 0.466, 1.194)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-20",
    "data-name": "a",
    d: "M.288,1.057,0,.1.48,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_175",
    "data-name": "Path 175",
    d: "M.288,0,0,.961l.48.1Z",
    transform: "translate(0.576 1.057) rotate(180)",
    fill: "#fc0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7381",
    "data-name": "Group 7381",
    transform: "matrix(-0.809, 0.588, -0.588, -0.809, 3.194, 3.68)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b-5",
    "data-name": "b",
    transform: "translate(0.714 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-21",
    "data-name": "a",
    d: "M.288,0,0,.961l.48.1Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_176",
    "data-name": "Path 176",
    d: "M.288,1.057,0,.1.48,0Z",
    transform: "translate(0.576 1.057) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "c-5",
    "data-name": "c",
    transform: "translate(0.713 0.39)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7376",
    "data-name": "Group 7376",
    transform: "translate(1.114 0) rotate(72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-22",
    "data-name": "a",
    d: "M.288,0,0,.961l.48.1Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_177",
    "data-name": "Path 177",
    d: "M.288,1.057,0,.1.48,0Z",
    transform: "translate(0.576 1.057) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7377",
    "data-name": "Group 7377",
    transform: "matrix(-0.809, 0.588, -0.588, -0.809, 1.087, 1.179)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-23",
    "data-name": "a",
    d: "M.288,0,0,.961l.48.1Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_178",
    "data-name": "Path 178",
    d: "M.288,1.057,0,.1.48,0Z",
    transform: "translate(0.576 1.057) rotate(180)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7380",
    "data-name": "Group 7380",
    transform: "translate(1.292 1.907) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7378",
    "data-name": "Group 7378",
    transform: "translate(0.109 1.191) rotate(-72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-24",
    "data-name": "a",
    d: "M.288,1.057,0,.1.48,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_179",
    "data-name": "Path 179",
    d: "M.288,0,0,.961l.48.1Z",
    transform: "translate(0.576 1.057) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7379",
    "data-name": "Group 7379",
    transform: "matrix(-0.809, -0.588, 0.588, -0.809, 0.466, 1.194)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-25",
    "data-name": "a",
    d: "M.288,1.057,0,.1.48,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180",
    "data-name": "Path 180",
    d: "M.288,0,0,.961l.48.1Z",
    transform: "translate(0.576 1.057) rotate(180)",
    fill: "#fc0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7387",
    "data-name": "Group 7387",
    transform: "translate(2.423 8.019) rotate(72)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b-6",
    "data-name": "b",
    transform: "translate(0.714 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-26",
    "data-name": "a",
    d: "M.288,0,0,.961l.48.1Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_181",
    "data-name": "Path 181",
    d: "M.288,1.057,0,.1.48,0Z",
    transform: "translate(0.576 1.057) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "c-6",
    "data-name": "c",
    transform: "translate(0.713 0.39)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7382",
    "data-name": "Group 7382",
    transform: "translate(1.114 0) rotate(72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-27",
    "data-name": "a",
    d: "M.288,0,0,.961l.48.1Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_182",
    "data-name": "Path 182",
    d: "M.288,1.057,0,.1.48,0Z",
    transform: "translate(0.576 1.057) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7383",
    "data-name": "Group 7383",
    transform: "matrix(-0.809, 0.588, -0.588, -0.809, 1.087, 1.179)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-28",
    "data-name": "a",
    d: "M.288,0,0,.961l.48.1Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_183",
    "data-name": "Path 183",
    d: "M.288,1.057,0,.1.48,0Z",
    transform: "translate(0.576 1.057) rotate(180)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7386",
    "data-name": "Group 7386",
    transform: "translate(1.292 1.907) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7384",
    "data-name": "Group 7384",
    transform: "translate(0.109 1.191) rotate(-72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-29",
    "data-name": "a",
    d: "M.288,1.057,0,.1.48,0Z",
    transform: "translate(0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_184",
    "data-name": "Path 184",
    d: "M.288,0,0,.961l.48.1Z",
    transform: "translate(0.576 1.057) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7385",
    "data-name": "Group 7385",
    transform: "matrix(-0.809, -0.588, 0.588, -0.809, 0.466, 1.194)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-30",
    "data-name": "a",
    d: "M.288,1.057,0,.1.48,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_185",
    "data-name": "Path 185",
    d: "M.288,0,0,.961l.48.1Z",
    transform: "translate(0.576 1.057) rotate(180)",
    fill: "#fc0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7393",
    "data-name": "Group 7393",
    transform: "translate(4.508 9.952) rotate(72)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b-7",
    "data-name": "b",
    transform: "translate(0.714 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-31",
    "data-name": "a",
    d: "M.288,0,0,.961l.48.1Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_186",
    "data-name": "Path 186",
    d: "M.288,1.057,0,.1.48,0Z",
    transform: "translate(0.576 1.057) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "c-7",
    "data-name": "c",
    transform: "translate(0.713 0.39)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7388",
    "data-name": "Group 7388",
    transform: "translate(1.114 0) rotate(72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-32",
    "data-name": "a",
    d: "M.288,0,0,.961l.48.1Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_187",
    "data-name": "Path 187",
    d: "M.288,1.057,0,.1.48,0Z",
    transform: "translate(0.576 1.057) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7389",
    "data-name": "Group 7389",
    transform: "matrix(-0.809, 0.588, -0.588, -0.809, 1.087, 1.179)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-33",
    "data-name": "a",
    d: "M.288,0,0,.961l.48.1Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_188",
    "data-name": "Path 188",
    d: "M.288,1.057,0,.1.48,0Z",
    transform: "translate(0.576 1.057) rotate(180)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7392",
    "data-name": "Group 7392",
    transform: "translate(1.292 1.907) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7390",
    "data-name": "Group 7390",
    transform: "translate(0.109 1.191) rotate(-72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-34",
    "data-name": "a",
    d: "M.288,1.057,0,.1.48,0Z",
    transform: "translate(0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_189",
    "data-name": "Path 189",
    d: "M.288,0,0,.961l.48.1Z",
    transform: "translate(0.576 1.057) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7391",
    "data-name": "Group 7391",
    transform: "matrix(-0.809, -0.588, 0.588, -0.809, 0.466, 1.194)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-35",
    "data-name": "a",
    d: "M.288,1.057,0,.1.48,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_190",
    "data-name": "Path 190",
    d: "M.288,0,0,.961l.48.1Z",
    transform: "translate(0.576 1.057) rotate(180)",
    fill: "#fc0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7424",
    "data-name": "Group 7424",
    transform: "translate(13.532 12.87) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7399",
    "data-name": "Group 7399",
    transform: "translate(0 5.199)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b-8",
    "data-name": "b",
    transform: "translate(0.714 0.85)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-36",
    "data-name": "a",
    d: "M.288,1.057,0,.1.48,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_191",
    "data-name": "Path 191",
    d: "M.288,0,0,.961l.48.1Z",
    transform: "translate(0.576 1.057) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "c-8",
    "data-name": "c",
    transform: "translate(0.713 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7394",
    "data-name": "Group 7394",
    transform: "translate(0.109 1.191) rotate(-72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-37",
    "data-name": "a",
    d: "M.288,1.057,0,.1.48,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_192",
    "data-name": "Path 192",
    d: "M.288,0,0,.961l.48.1Z",
    transform: "translate(0.576 1.057) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7395",
    "data-name": "Group 7395",
    transform: "matrix(-0.809, -0.588, 0.588, -0.809, 0.466, 1.194)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-38",
    "data-name": "a",
    d: "M.288,1.057,0,.1.48,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_193",
    "data-name": "Path 193",
    d: "M.288,0,0,.961l.48.1Z",
    transform: "translate(0.576 1.057) rotate(180)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7398",
    "data-name": "Group 7398",
    transform: "translate(1.292 1.517) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7396",
    "data-name": "Group 7396",
    transform: "translate(1.114 0) rotate(72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-39",
    "data-name": "a",
    d: "M.288,0,0,.961l.48.1Z",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_194",
    "data-name": "Path 194",
    d: "M.288,1.057,0,.1.48,0Z",
    transform: "translate(0.576 1.057) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7397",
    "data-name": "Group 7397",
    transform: "matrix(-0.809, 0.588, -0.588, -0.809, 1.087, 1.179)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-40",
    "data-name": "a",
    d: "M.288,0,0,.961l.48.1Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_195",
    "data-name": "Path 195",
    d: "M.288,1.057,0,.1.48,0Z",
    transform: "translate(0.576 1.057) rotate(180)",
    fill: "#fc0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7405",
    "data-name": "Group 7405",
    transform: "matrix(-0.809, 0.588, -0.588, -0.809, 5.323, 11.27)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b-9",
    "data-name": "b",
    transform: "translate(0.714 0.85)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-41",
    "data-name": "a",
    d: "M.288,1.057,0,.1.48,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_196",
    "data-name": "Path 196",
    d: "M.288,0,0,.961l.48.1Z",
    transform: "translate(0.576 1.057) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "c-9",
    "data-name": "c",
    transform: "translate(0.713 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7400",
    "data-name": "Group 7400",
    transform: "translate(0.109 1.191) rotate(-72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-42",
    "data-name": "a",
    d: "M.288,1.057,0,.1.48,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_197",
    "data-name": "Path 197",
    d: "M.288,0,0,.961l.48.1Z",
    transform: "translate(0.576 1.057) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7401",
    "data-name": "Group 7401",
    transform: "matrix(-0.809, -0.588, 0.588, -0.809, 0.466, 1.194)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-43",
    "data-name": "a",
    d: "M.288,1.057,0,.1.48,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_198",
    "data-name": "Path 198",
    d: "M.288,0,0,.961l.48.1Z",
    transform: "translate(0.576 1.057) rotate(180)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7404",
    "data-name": "Group 7404",
    transform: "translate(1.292 1.517) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7402",
    "data-name": "Group 7402",
    transform: "translate(1.114 0) rotate(72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-44",
    "data-name": "a",
    d: "M.288,0,0,.961l.48.1Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_199",
    "data-name": "Path 199",
    d: "M.288,1.057,0,.1.48,0Z",
    transform: "translate(0.576 1.057) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7403",
    "data-name": "Group 7403",
    transform: "matrix(-0.809, 0.588, -0.588, -0.809, 1.087, 1.179)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-45",
    "data-name": "a",
    d: "M.288,0,0,.961l.48.1Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_200",
    "data-name": "Path 200",
    d: "M.288,1.057,0,.1.48,0Z",
    transform: "translate(0.576 1.057) rotate(180)",
    fill: "#fc0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7411",
    "data-name": "Group 7411",
    transform: "matrix(-0.809, -0.588, 0.588, -0.809, 2.073, 10.312)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b-10",
    "data-name": "b",
    transform: "translate(0.714 0.85)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-46",
    "data-name": "a",
    d: "M.288,1.057,0,.1.48,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_201",
    "data-name": "Path 201",
    d: "M.288,0,0,.961l.48.1Z",
    transform: "translate(0.576 1.057) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "c-10",
    "data-name": "c",
    transform: "translate(0.713 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7406",
    "data-name": "Group 7406",
    transform: "translate(0.109 1.191) rotate(-72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-47",
    "data-name": "a",
    d: "M.288,1.057,0,.1.48,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_202",
    "data-name": "Path 202",
    d: "M.288,0,0,.961l.48.1Z",
    transform: "translate(0.576 1.057) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7407",
    "data-name": "Group 7407",
    transform: "matrix(-0.809, -0.588, 0.588, -0.809, 0.466, 1.194)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-48",
    "data-name": "a",
    d: "M.288,1.057,0,.1.48,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_203",
    "data-name": "Path 203",
    d: "M.288,0,0,.961l.48.1Z",
    transform: "translate(0.576 1.057) rotate(180)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7410",
    "data-name": "Group 7410",
    transform: "translate(1.292 1.517) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7408",
    "data-name": "Group 7408",
    transform: "translate(1.114 0) rotate(72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-49",
    "data-name": "a",
    d: "M.288,0,0,.961l.48.1Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_204",
    "data-name": "Path 204",
    d: "M.288,1.057,0,.1.48,0Z",
    transform: "translate(0.576 1.057) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7409",
    "data-name": "Group 7409",
    transform: "matrix(-0.809, 0.588, -0.588, -0.809, 1.087, 1.179)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-50",
    "data-name": "a",
    d: "M.288,0,0,.961l.48.1Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_205",
    "data-name": "Path 205",
    d: "M.288,1.057,0,.1.48,0Z",
    transform: "translate(0.576 1.057) rotate(180)",
    fill: "#fc0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7417",
    "data-name": "Group 7417",
    transform: "translate(0.609 3.841) rotate(-72)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b-11",
    "data-name": "b",
    transform: "translate(0.714 0.85)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-51",
    "data-name": "a",
    d: "M.288,1.057,0,.1.48,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_206",
    "data-name": "Path 206",
    d: "M.288,0,0,.961l.48.1Z",
    transform: "translate(0.576 1.057) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "c-11",
    "data-name": "c",
    transform: "translate(0.713 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7412",
    "data-name": "Group 7412",
    transform: "translate(0.109 1.191) rotate(-72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-52",
    "data-name": "a",
    d: "M.288,1.057,0,.1.48,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_207",
    "data-name": "Path 207",
    d: "M.288,0,0,.961l.48.1Z",
    transform: "translate(0.576 1.057) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7413",
    "data-name": "Group 7413",
    transform: "matrix(-0.809, -0.588, 0.588, -0.809, 0.466, 1.194)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-53",
    "data-name": "a",
    d: "M.288,1.057,0,.1.48,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_208",
    "data-name": "Path 208",
    d: "M.288,0,0,.961l.48.1Z",
    transform: "translate(0.576 1.057) rotate(180)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7416",
    "data-name": "Group 7416",
    transform: "translate(1.292 1.517) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7414",
    "data-name": "Group 7414",
    transform: "translate(1.114 0) rotate(72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-54",
    "data-name": "a",
    d: "M.288,0,0,.961l.48.1Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_209",
    "data-name": "Path 209",
    d: "M.288,1.057,0,.1.48,0Z",
    transform: "translate(0.576 1.057) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7415",
    "data-name": "Group 7415",
    transform: "matrix(-0.809, 0.588, -0.588, -0.809, 1.087, 1.179)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-55",
    "data-name": "a",
    d: "M.288,0,0,.961l.48.1Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_210",
    "data-name": "Path 210",
    d: "M.288,1.057,0,.1.48,0Z",
    transform: "translate(0.576 1.057) rotate(180)",
    fill: "#fc0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7423",
    "data-name": "Group 7423",
    transform: "translate(2.694 1.907) rotate(-72)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b-12",
    "data-name": "b",
    transform: "translate(0.714 0.85)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-56",
    "data-name": "a",
    d: "M.288,1.057,0,.1.48,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_211",
    "data-name": "Path 211",
    d: "M.288,0,0,.961l.48.1Z",
    transform: "translate(0.576 1.057) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "c-12",
    "data-name": "c",
    transform: "translate(0.713 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7418",
    "data-name": "Group 7418",
    transform: "translate(0.109 1.191) rotate(-72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-57",
    "data-name": "a",
    d: "M.288,1.057,0,.1.48,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_212",
    "data-name": "Path 212",
    d: "M.288,0,0,.961l.48.1Z",
    transform: "translate(0.576 1.057) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7419",
    "data-name": "Group 7419",
    transform: "matrix(-0.809, -0.588, 0.588, -0.809, 0.466, 1.194)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-58",
    "data-name": "a",
    d: "M.288,1.057,0,.1.48,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_213",
    "data-name": "Path 213",
    d: "M.288,0,0,.961l.48.1Z",
    transform: "translate(0.576 1.057) rotate(180)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7422",
    "data-name": "Group 7422",
    transform: "translate(1.292 1.517) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7420",
    "data-name": "Group 7420",
    transform: "translate(1.114 0) rotate(72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-59",
    "data-name": "a",
    d: "M.288,0,0,.961l.48.1Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_214",
    "data-name": "Path 214",
    d: "M.288,1.057,0,.1.48,0Z",
    transform: "translate(0.576 1.057) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7421",
    "data-name": "Group 7421",
    transform: "matrix(-0.809, 0.588, -0.588, -0.809, 1.087, 1.179)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-60",
    "data-name": "a",
    d: "M.288,0,0,.961l.48.1Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_215",
    "data-name": "Path 215",
    d: "M.288,1.057,0,.1.48,0Z",
    transform: "translate(0.576 1.057) rotate(180)",
    fill: "#fc0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "_240-japan",
    "data-name": "240-japan",
    transform: "translate(76.288 143.057)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_40",
    "data-name": "Rectangle 40",
    width: 30.545,
    height: 20.364,
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 5.727,
    cy: 5.727,
    rx: 5.727,
    ry: 5.727,
    transform: "translate(9.545 4.454)",
    fill: "#d80027"
  })), /*#__PURE__*/React.createElement("g", {
    id: "hk",
    transform: "translate(159.948 182.061)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23582",
    "data-name": "Path 23582",
    d: "M-75.746,20.363H-106.6V0h30.85Z",
    transform: "translate(21.966)",
    fill: "#ba0000",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23583",
    "data-name": "Path 23583",
    d: "M186.942,104.74a2.979,2.979,0,0,1-.06-5.437,6.13,6.13,0,0,1,1.312-.227.981.981,0,0,0-.266.358.857.857,0,0,0,.107.736,2.123,2.123,0,0,1,.294.939,1.456,1.456,0,0,1-.581,1.34c-.262.2-.573.274-.827.505a1.081,1.081,0,0,0-.358.72A1.4,1.4,0,0,0,186.942,104.74Z",
    transform: "translate(-257.442 -94.884)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23584",
    "data-name": "Path 23584",
    d: "M218.08,154.36v-.012",
    transform: "translate(-288.973 -147.817)",
    fill: "#ba0000",
    stroke: "#000",
    strokeWidth: 1.974,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23585",
    "data-name": "Path 23585",
    d: "M207.911,157.7a2.515,2.515,0,0,1-.119-3.074",
    transform: "translate(-278.673 -148.088)",
    fill: "none",
    stroke: "#ba0000",
    strokeWidth: 1.974
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23586",
    "data-name": "Path 23586",
    d: "M218.581,137.218l.131.219-.239-.1-.187.2.032-.259-.239-.1.259-.06.032-.255.131.219.262-.06",
    transform: "translate(-288.973 -131.073)",
    fill: "#ba0000",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23587",
    "data-name": "Path 23587",
    d: "M231.522,170.091a2.976,2.976,0,0,1,5.182-1.647,6.018,6.018,0,0,1,.6,1.185.942.942,0,0,0-.422-.147.844.844,0,0,0-.668.314,2.116,2.116,0,0,1-.811.557,1.456,1.456,0,0,1-1.452-.159c-.27-.195-.43-.469-.724-.644a1.122,1.122,0,0,0-.8-.135A1.41,1.41,0,0,0,231.522,170.091Z",
    transform: "translate(-301.846 -160.386)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23588",
    "data-name": "Path 23588",
    d: "M303.62,197.588h.012",
    transform: "translate(-370.894 -189.228)",
    fill: "#ba0000",
    stroke: "#000",
    strokeWidth: 1.974,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23589",
    "data-name": "Path 23589",
    d: "M235,195.432a2.522,2.522,0,0,1,2.907-1.018",
    transform: "translate(-305.177 -186.046)",
    fill: "none",
    stroke: "#ba0000",
    strokeWidth: 1.974
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23590",
    "data-name": "Path 23590",
    d: "M307.39,194.889l-.171.187.024-.259L307,194.7l.251-.04.024-.266.135.239.255-.048-.171.187.131.239",
    transform: "translate(-374.135 -186.167)",
    fill: "#ba0000",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23591",
    "data-name": "Path 23591",
    d: "M235.094,232.023a2.98,2.98,0,0,1,3.21,4.391,6.186,6.186,0,0,1-.935.947.938.938,0,0,0,0-.445.832.832,0,0,0-.509-.537,2.112,2.112,0,0,1-.787-.6,1.456,1.456,0,0,1-.306-1.424c.1-.318.306-.557.378-.891a1.114,1.114,0,0,0-.123-.8A1.43,1.43,0,0,0,235.094,232.023Z",
    transform: "translate(-305.267 -222.159)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23592",
    "data-name": "Path 23592",
    d: "M288.11,291.494l.008.008",
    transform: "translate(-356.04 -279.161)",
    fill: "#ba0000",
    stroke: "#000",
    strokeWidth: 1.974,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23593",
    "data-name": "Path 23593",
    d: "M243.46,234.06a2.527,2.527,0,0,1,1.885,2.438",
    transform: "translate(-313.279 -224.157)",
    fill: "none",
    stroke: "#ba0000",
    strokeWidth: 1.974
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23594",
    "data-name": "Path 23594",
    d: "M278.663,296.342l-.235-.1.259-.06.032-.266.123.227.259-.06-.179.2.119.227-.231-.1-.179.2",
    transform: "translate(-346.768 -283.392)",
    fill: "#ba0000",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23595",
    "data-name": "Path 23595",
    d: "M132.42,238.388a2.979,2.979,0,0,1-3.313,4.311,6.193,6.193,0,0,1-1.173-.632.929.929,0,0,0,.434-.119.847.847,0,0,0,.37-.636,2.108,2.108,0,0,1,.35-.927,1.456,1.456,0,0,1,1.281-.7c.334,0,.62.143.962.119a1.149,1.149,0,0,0,.732-.35,1.42,1.42,0,0,0,.358-1.074Z",
    transform: "translate(-202.641 -228.298)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23596",
    "data-name": "Path 23596",
    d: "M192.7,305.782l0,.008",
    transform: "translate(-264.667 -292.844)",
    fill: "#ba0000",
    stroke: "#000",
    strokeWidth: 1.974,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23597",
    "data-name": "Path 23597",
    d: "M194.412,246.656a2.5,2.5,0,0,1-1.806,2.494",
    transform: "translate(-264.577 -236.22)",
    fill: "none",
    stroke: "#ba0000",
    strokeWidth: 1.974
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23598",
    "data-name": "Path 23598",
    d: "M171.809,300.115l.036-.255.131.227.262-.04-.183.183.131.227-.243-.115-.183.183.032-.255-.243-.115",
    transform: "translate(-244.412 -287.173)",
    fill: "#ba0000",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23599",
    "data-name": "Path 23599",
    d: "M111.292,169.567a2.973,2.973,0,0,1-5.166-1.686,6.094,6.094,0,0,1,.2-1.312,1.018,1.018,0,0,0,.259.366.859.859,0,0,0,.728.135,2.068,2.068,0,0,1,.982.024,1.456,1.456,0,0,1,1.086.978c.107.314.072.632.211.947a1.12,1.12,0,0,0,.569.573,1.4,1.4,0,0,0,1.13-.02Z",
    transform: "translate(-181.756 -159.52)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23600",
    "data-name": "Path 23600",
    d: "M150.878,221l-.008,0",
    transform: "translate(-224.607 -211.644)",
    fill: "#ba0000",
    stroke: "#000",
    strokeWidth: 1.974,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23601",
    "data-name": "Path 23601",
    d: "M154.1,221.681a2.514,2.514,0,0,1-2.951-.875",
    transform: "translate(-224.877 -211.464)",
    fill: "none",
    stroke: "#ba0000",
    strokeWidth: 1.974
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23602",
    "data-name": "Path 23602",
    d: "M136.8,201.489l.251-.052-.171.2.123.235-.231-.111-.171.2.028-.27-.235-.111.251-.052.028-.27",
    transform: "translate(-210.743 -192.739)",
    fill: "#ba0000",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "sg",
    transform: "translate(76.4 25.057)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23604",
    "data-name": "Path 23604",
    d: "M-20,0H13.276V22.184H-20Z",
    transform: "translate(19.076)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23605",
    "data-name": "Path 23605",
    d: "M-20,0H13.276V11.092H-20Z",
    transform: "translate(19.076)",
    fill: "#df0000",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23606",
    "data-name": "Path 23606",
    d: "M41.988,37.04a3.9,3.9,0,0,0,.037,7.635,3.968,3.968,0,1,1-2.2-7.626,3.8,3.8,0,0,1,2.168-.009Z",
    transform: "translate(-35.24 -35.182)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23607",
    "data-name": "Path 23607",
    d: "M105.34,53.918l.226.693-.6-.425-.592.434.217-.7-.592-.43.735-.009.231-.693.231.693h.73Zm.809,2.4.231.7-.6-.425-.6.43.222-.7-.592-.434.735,0,.226-.7.231.693h.739Zm2.7-.018.226.7-.6-.43-.592.43.217-.7-.592-.43.735-.009.231-.693.231.693h.73Zm.8-2.385.226.7-.6-.425-.592.43.222-.7-.6-.434.739,0,.222-.7.231.693h.739Zm-2.14-1.585.231.7-.6-.43-.6.434.222-.7-.592-.434.73,0,.231-.7.231.693h.739Z",
    transform: "translate(-99.193 -48.834)",
    fill: "#fff",
    fillRule: "evenodd"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14248",
    "data-name": "Group 14248",
    transform: "translate(1344.619 3190)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3076-2",
    "data-name": "Rectangle 3076",
    fill: "#fff",
    stroke: "#dae2d6",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 293.381,
    height: 218.385,
    rx: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 292.381,
    height: 217.385,
    rx: 11.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8602",
    "data-name": "Group 8602",
    transform: "translate(13.815 26.709)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Local_channels_details",
    "data-name": "Local channels details",
    transform: "translate(41.445 20)",
    fill: "#030303",
    fontSize: 18,
    fontFamily: "Poppins-SemiBold, Poppins",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Local channels details")), /*#__PURE__*/React.createElement("text", {
    id: "Account_number_GB92TCCL04140465845215",
    "data-name": "Account number GB92TCCL04140465845215",
    transform: "translate(6.447 50.84)",
    fill: "#777",
    fontSize: 13,
    fontFamily: "Poppins-Light, Poppins",
    fontWeight: 300
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Account number"), /*#__PURE__*/React.createElement("tspan", {
    fill: "#111",
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 19
  }, "GB92TCCL04140465845215"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8596",
    "data-name": "Group 8596",
    transform: "translate(0 86.575)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3077",
    "data-name": "Rectangle 3077",
    width: 261.146,
    height: 90,
    rx: 6,
    fill: "#fee"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8499",
    "data-name": "Group 8499",
    transform: "translate(15.657 15.657)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "To_receive_USD_from_US_only.",
    "data-name": "To receive USD from US only.",
    transform: "translate(23.946)",
    fill: "#111",
    fontSize: 13,
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 14
  }, "To receive USD from US only.")), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-check-circle-3",
    "data-name": "Icon awesome-check-circle",
    d: "M14.032,7.3A6.735,6.735,0,1,1,7.3.563,6.735,6.735,0,0,1,14.032,7.3ZM6.518,10.863l5-5a.435.435,0,0,0,0-.614L10.9,4.638a.434.434,0,0,0-.615,0L6.211,8.713l-1.9-1.9a.435.435,0,0,0-.615,0l-.614.614a.435.435,0,0,0,0,.614L5.9,10.863a.435.435,0,0,0,.615,0Z",
    transform: "translate(-0.563 2.201)",
    fill: "#2bd06f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8500",
    "data-name": "Group 8500",
    transform: "translate(15.657 42.366)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "DO_NOT_use_to_receive_funds_from_outside_US.",
    "data-name": "DO NOT use to receive funds from outside US.",
    transform: "translate(23.946)",
    fill: "#f21f1f",
    fontSize: 13,
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500,
    letterSpacing: "-0.018em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 14
  }, "DO NOT "), /*#__PURE__*/React.createElement("tspan", {
    y: 14,
    fill: "#111"
  }, "use to receive funds "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 34,
    fill: "#111"
  }, "from outside US.")), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-close-circle",
    "data-name": "Icon ionic-md-close-circle",
    d: "M10.11,3.375a6.735,6.735,0,1,0,6.735,6.735A6.712,6.712,0,0,0,10.11,3.375Zm3.367,9.159-.943.943L10.11,11.053,7.685,13.477l-.943-.943L9.167,10.11,6.742,7.685l.943-.943L10.11,9.167l2.425-2.424.943.943L11.053,10.11Z",
    transform: "translate(-3.375 -1.448)",
    fill: "#f21f6c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "local_seo_globe",
    transform: "translate(6.447 0.921)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "international_finance_x2C__globe_x2C__money_flow_x2C__money_turnover_4_",
    transform: "translate(0 5.95)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "global_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8479",
    "data-name": "Group 8479"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8476",
    "data-name": "Group 8476",
    transform: "translate(3.102 3.144)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1496",
    "data-name": "Path 1496",
    d: "M23.893,26.1a.467.467,0,0,1-.134-.019,29.159,29.159,0,0,0-16.388,0,.477.477,0,0,1-.268-.915,30.144,30.144,0,0,1,16.925,0,.477.477,0,0,1-.134.934Z",
    transform: "translate(-6.76 -13.014)",
    fill: "#030303",
    stroke: "#030303",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1497",
    "data-name": "Path 1497",
    d: "M16.552,29.065a.476.476,0,0,1-.269-.87A13.351,13.351,0,0,0,22.147,17.18a13.106,13.106,0,0,0-1.336-5.8.476.476,0,0,1,.856-.419A14.046,14.046,0,0,1,23.1,17.18a14.307,14.307,0,0,1-6.279,11.8A.482.482,0,0,1,16.552,29.065Z",
    transform: "translate(-7.199 -10.549)",
    fill: "#030303",
    stroke: "#030303",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1498",
    "data-name": "Path 1498",
    d: "M15.1,29.058a.475.475,0,0,1-.269-.083,14.307,14.307,0,0,1-6.279-11.8A14.024,14.024,0,0,1,10.062,10.8a.476.476,0,1,1,.851.429,13.093,13.093,0,0,0-1.407,5.94A13.355,13.355,0,0,0,15.37,28.188a.476.476,0,0,1-.269.87Z",
    transform: "translate(-6.845 -10.541)",
    fill: "#030303",
    stroke: "#030303",
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8477",
    "data-name": "Group 8477",
    transform: "translate(11.43 8.472)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1499",
    "data-name": "Path 1499",
    d: "M15.976,29.222a.477.477,0,0,1-.476-.476V16.608a.476.476,0,0,1,.953,0V28.745A.476.476,0,0,1,15.976,29.222Z",
    transform: "translate(-15.5 -16.132)",
    fill: "#030303",
    stroke: "#030303",
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8478",
    "data-name": "Group 8478",
    transform: "translate(1.754 9.299)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1500",
    "data-name": "Path 1500",
    d: "M26.332,17.953H5.822a.476.476,0,1,1,0-.953h20.51a.476.476,0,0,1,0,.953Z",
    transform: "translate(-5.346 -17)",
    fill: "#030303",
    stroke: "#030303",
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1501",
    "data-name": "Path 1501",
    d: "M15.412,28.924A11.906,11.906,0,0,1,6.989,8.594,12.118,12.118,0,0,1,8.475,7.332a.477.477,0,0,1,.557.775A10.96,10.96,0,1,0,23.162,9.269,11.079,11.079,0,0,0,21.9,8.185a.476.476,0,0,1,.564-.767A12.2,12.2,0,0,1,23.836,8.6a11.905,11.905,0,0,1-8.424,20.329Z",
    transform: "translate(-3.506 -7.242)",
    fill: "#030303",
    stroke: "#030303",
    strokeWidth: 0.8
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8481",
    "data-name": "Group 8481",
    transform: "translate(7.142)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_2",
    "data-name": "Union 2",
    d: "M4.409,13.186C4.233,12.986,0,8.244,0,4.6A4.694,4.694,0,0,1,4.765,0,4.7,4.7,0,0,1,9.53,4.6c0,3.64-4.231,8.382-4.411,8.581a.482.482,0,0,1-.711,0ZM8.579,4.6A3.737,3.737,0,0,0,4.765.957,3.736,3.736,0,0,0,.953,4.6,3.736,3.736,0,0,1,4.765.957,3.737,3.737,0,0,1,8.579,4.6Z",
    fill: "#12a15a",
    stroke: "#12a15a",
    strokeWidth: 0.8
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank1);
export default __webpack_public_path__ + "static/media/bank-1.04a5f06493751bb113e055535ffa789a.svg";
export { ForwardRef as ReactComponent };